import { api } from '../core';
import { MEDICAL_RECORDS_TAG } from '../constants';

export type DocumentUploadCancelledUnassignedResponse = object;

type DocumentUploadCancelledUnassignedProps = {
  documentId: string | null;
  unassignedDocumentId: string | null;
};

const documentUploadCancelledUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentUploadCancelledUnassigned: builder.query<
      DocumentUploadCancelledUnassignedResponse,
      DocumentUploadCancelledUnassignedProps
    >({
      query: ({ documentId, unassignedDocumentId }: DocumentUploadCancelledUnassignedProps) => ({
        url: `document/upload-cancelled/unassigned`,
        method: 'POST',
        body: {
          documentId: documentId,
          unassignedDocumentId: unassignedDocumentId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([MEDICAL_RECORDS_TAG]));
        } catch (error) {
          console.error('Error in postDocumentUploadCancelledUnassigned in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentUploadCancelledUnassignedQuery } = documentUploadCancelledUnassignedApi;
